/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchecalendrierClasseDto } from './FcbRecherchecalendrierClasseDto';
import {
    FcbRecherchecalendrierClasseDtoFromJSON,
    FcbRecherchecalendrierClasseDtoFromJSONTyped,
    FcbRecherchecalendrierClasseDtoToJSON,
} from './FcbRecherchecalendrierClasseDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchecalendrierClasseDtoPaginatedResults
 */
export interface FcbRecherchecalendrierClasseDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchecalendrierClasseDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchecalendrierClasseDto>}
     * @memberof FcbRecherchecalendrierClasseDtoPaginatedResults
     */
    results?: Array<FcbRecherchecalendrierClasseDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchecalendrierClasseDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchecalendrierClasseDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchecalendrierClasseDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchecalendrierClasseDtoPaginatedResultsFromJSON(json: any): FcbRecherchecalendrierClasseDtoPaginatedResults {
    return FcbRecherchecalendrierClasseDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchecalendrierClasseDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchecalendrierClasseDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchecalendrierClasseDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchecalendrierClasseDtoPaginatedResultsToJSON(value?: FcbRecherchecalendrierClasseDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchecalendrierClasseDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

